$ = require 'jquery'
{ map, compact, union, pluck, difference } = require 'lodash'
{ getBgImg } = require './css-val'

###
@dependsOn jquery
@dependsOn lodash
@dependsOn css-val
###
module.exports =
class PreloadImage

  @data: []

  ###
  create PreloadImage instance
  @param $el [jQueryObject] element
  @param images [Array] images
  ###
  constructor: (@el, @images = []) ->
    $el = $ @el
    @loaded = 0

    ua     = window.navigator.userAgent.toLowerCase()
    @isIE9 = ua.indexOf('msie 9.') != -1

    images = map $el.find('img'), (img) ->
      img.src

    bgImages = compact map $el.find('*'), (el) ->
      getBgImg $(el)
    bgImg = getBgImg $el
    bgImages.push(bgImg) if bgImg

    data = pluck PreloadImage.data, 'src'
    @images = union @images, images, bgImages
    @images = difference @images, data

  ###
  load images
  ###
  load: ->
    deferreds = map @images, (src, i) =>
      dfd = $.Deferred()
      img = new Image

      loadend = =>
        @loaded++
        dfd.resolve()

      success = ->
        PreloadImage.data.push
          src   : img.src
          width : img.width
          height: img.height

      if !@isIE9
        img.onload = =>
          success()
          loadend()
        img.onerror = =>
          loadend()
      else
        timer = ->
          setTimeout =>
            if img.width
              success()
              loadend()
            else
              timer()
          , 100
        timer()

      img.src = src
      dfd.promise()

    $.when deferreds...



// WEBPACK FOOTER //
// ./webpack/requires/components/preload-image.coffee